module.exports = __webpack_public_path__ + "img/yibaoxian.dfa660ce.png";